<template>
  <div id="scroll-container-id" class="scroll-container" @scroll="handlerScroll">
    <v-header :activePage="'首页'"></v-header>

    <div class="main_quality_center" v-if="(isEmpty(plantIdSelected) === false) && (isEmpty(globalPlantList) === false)">
      <el-row type="flex" justify="center" class="main_title">
        <h3>{{ $parseLabel('质量看板') }}</h3>
      </el-row>
      <div class="main_plant_select">
        <ul>
          <li v-for="plantItem in globalPlantList" :key="plantItem.plantId" @click="handlePlantChange(plantItem.plantId)">
            <div :class="(plantIdSelected === plantItem.plantId) ? 'plant_item active' : 'plant_item'">
              <span>{{ $parseLabel(plantItem.plantName) }}</span>
            </div>
          </li>
        </ul>
      </div>

      <div class="main_chart_grid">
        <el-row type="flex" justify="space-between">
          <el-col class="main_chart_col" @click.native="gotoChart('customer_dppm')">
            <div class="main_chart_item">
              <h3>{{ $parseLabel('战略客户DPPM') }}</h3>
              <customer-dppm 
                :plantId="plantIdSelected"
                :chartId="'customer_dppm'" 
                :chartData="customerDppmData" 
                :barTitle="$parseLabel('DPPM')"
                :lineTitle="$parseLabel('目标')"
                :width="'100%'" 
                :height="'400px'"
              />
            </div>        
          </el-col>

          <el-col class="main_chart_col" @click.native="gotoChart('customer_score')">
            <div class="main_chart_item">
              <h3>{{ $parseLabel('客户评价') }}</h3>
              <customer-dppm 
                :plantId="plantIdSelected"
                :chartId="'customer_score'" 
                :chartData="customerScoreChartData" 
                :barTitle="$parseLabel('评分')"
                :lineTitle="$parseLabel('目标')"
                :width="'100%'" 
                :height="'400px'"/>
            </div>        
          </el-col>

          <el-col class="main_chart_col" @click.native="gotoChart('customer_complaints')">
            <div class="main_chart_item">
              <h3>{{ $parseLabel('客户投诉次数 (Case)') }}</h3>
              <customer-complaints 
                :plantId="plantIdSelected"
                :chartId="'customer_complaints'" 
                :chartData="customerComplaintsData" 
                :barTitle="$parseLabel('投诉次数')"
                :lineTitle="$parseLabel('目标')"
                :width="'100%'" 
                :height="'400px'"/>
            </div>        
          </el-col>
        </el-row>

        <el-row type="flex" justify="space-between">
          <el-col class="main_chart_col" @click.native="gotoChart('customer_pass_ratio')">
            <div class="main_chart_item">
              <h3>{{ $parseLabel('客户审核通过率 (%)') }}</h3>
              <!-- bar + target line % -->
              <customer-pass-ratio 
                :plantId="plantIdSelected"
                :chartId="'customer_pass_ratio'" 
                :chartData="customerPassRatioData" 
                :ratioTitle="$parseLabel('通过率')"
                :lineTitle="$parseLabel('目标')"
                :width="'100%'" 
                :height="'400px'"/>
            </div>        
          </el-col>        

          <el-col class="main_chart_col" @click.native="gotoChart('failure_times_comparation')">
            <div class="main_chart_item">
              <h3>{{ $parseLabel('送样失败次数/小批失败次数(Case)') }}</h3>
              <!-- bar +target line -->
              <failure-times 
                :plantId="plantIdSelected"
                :chartId="'failure_times_comparation'" 
                :chartData="failureTimesData" 
                :timesTitle="$parseLabel('失败次数')"
                :lineTitle="$parseLabel('目标')"
                :width="'100%'" 
                :height="'400px'"/>
            </div>        
          </el-col>

          <el-col class="main_chart_col" @click.native="gotoChart('appearance_dppm')">
            <div class="main_chart_item">
              <h3>{{ $parseLabel('QA外观DPPM') }}</h3>
              <!-- bar +target line -->
              <appearance-dppm 
                :plantId="plantIdSelected"
                :chartId="'appearance_dppm'" 
                :chartData="appearanceDppmData" 
                :barTitle="$parseLabel('DPPM')"
                :lineTitle="$parseLabel('目标')"
                :width="'100%'" 
                :height="'400px'"/>
            </div>        
          </el-col>
        </el-row>

        <el-row type="flex" justify="space-between">
          <el-col class="main_chart_col" @click.native="gotoChart('function_dppm')">
            <div class="main_chart_item">
              <h3>{{ $parseLabel('QA功能DPPM') }}</h3>
              <!-- bar +target line -->
              <function-dppm 
                :plantId="plantIdSelected"
                :chartId="'function_dppm'" 
                :chartData="functionDppmData" 
                :barTitle="$parseLabel('DPPM')"
                :lineTitle="$parseLabel('目标')"
                :width="'100%'" 
                :height="'400px'"/>
            </div>        
          </el-col>

          <el-col class="main_chart_col" @click.native="gotoChart('materiallar')">
            <div class="main_chart_item">
              <h3>{{ $parseLabel('来料批次合格率(LAR) (%)') }}</h3>
              <!-- line + target line % -->
              <lar-chart 
                :plantId="plantIdSelected"
                :chartId="'materiallar'" 
                :chartData="larChartData" 
                :ratioTitle="$parseLabel('合格率')"
                :lineTitle="$parseLabel('目标')"
                :width="'100%'" 
                :height="'400px'"/>
            </div>        
          </el-col>

          <el-col class="main_chart_col" @click.native="gotoChart('cost_damage')">
            <div class="main_chart_item">
              <h3>{{ $parseLabel('质量成本损失率(%)') }}</h3>
              <!-- line + target line % -->
              <damage-ratio-chart 
                :plantId="plantIdSelected"
                :chartId="'cost_damage'" 
                :chartData="damageRatioChartData" 
                :ratioTitle="$parseLabel('损失率')"
                :lineTitle="$parseLabel('目标')"
                :width="'100%'" 
                :height="'400px'"/>
            </div>       
          </el-col>   
        </el-row>     
      </div>
    </div>
<!-- 
    <div class="main_module">
      <el-row type="flex" justify="center" class="main_title wow fadeInUp"  style="visibility: visible; animation-name: fadeInUp; animation-delay: 10s;">
        <h3>{{ $parseLabel('质量管理模块') }}</h3>
      </el-row>

      <div class="main_module_select">
        <ul>
          <li v-for="appTabItem in appTabList" :key="appTabItem.appTabId" @click="handleAppTabChange(appTabItem)">
            <el-row :class="(appTabSelected.appTabId === appTabItem.appTabId) ? 'app_type_item active' : 'app_type_item'">
              <span><i :class="`'icon iconfont ' + ${appTabItem.appTabIcon}`"></i> {{ $parseLabel(appTabItem.appTabName) }}</span>
            </el-row>
          </li>
        </ul>
      </div>

      <div class="main_module_container">
        <ul>
          <li v-for="(appItem, index) in appTabSelected.appList" :key="index" @click="open(appItem)" :style="{'width': `${appItem.span}`}">
            <el-row :class="(appTabSelected.appTabId === 52000)? 'module_item_panel module_item_panel_process' : 'module_item_panel'">
              <div :class="appItem.status == 0 ? 'cover_bg hui' : 'cover_bg'" type="flex" justify="center">
                <img class="module_cover" :src="appItem.cover" alt=""/>
                <div class="ccx_mask"></div>
                <p>{{ $parseLabel(appItem.title) }} </p>
              </div>
            </el-row>

          </li>
        </ul>
      </div>

    </div> -->

    <div class="main_carousel">
      <el-row type="flex">
        <el-row type="flex" justify="center" class="main_title">
        <h3>{{ $parseLabel('质量之声') }}</h3>

        </el-row>

        <div class="module_right" v-if="isEmpty(moduleSelected) === false">
            <el-dropdown>
              <span class="el-dropdown-link">
                {{ $parseLabel(moduleSelected.moduleName) }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" v-if="(false === isEmpty(moduleList)) && (moduleSelected !== undefined)">
                <el-dropdown-item
                  v-for="item in moduleList"
                  :key="item.moduleId"
                  @click.native="handleModuleSelected(item)"
                  >{{ $parseLabel(item.moduleName) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <p @click="jumpList()">{{ $parseLabel('更多') }}</p>
          </div> 

      </el-row>

      
   
      
      <el-row class="main_carousel_section" type="flex">
        <el-row class="prev" type="flex" justify="center" v-show="(isEmpty(wrapperVoiceList) === false) && (wrapperVoiceList.length > 1)">
          <i class="el-icon-arrow-left" @click="arrowClick('prev')"></i>
        </el-row>
        <el-carousel 
          ref="carouselRef"
          class="carousel"
          height="410px"
          indicator-position="none"
          :autoplay="false"
          :interval="5000"
          arrow="never">
          <el-carousel-item 
            v-for="(subVoiceList, subVoiceIndex) in wrapperVoiceList" 
            :key="subVoiceIndex"
            class="main_carousel_section_container"
            >
            <el-row type="flex" class="carousel_row">
              <div class="carousel_col" v-for="(voiceItem, index) in subVoiceList" :key="index">
                <div class="main_carousel_item" @click="jump(voiceItem)">
                  <el-row class="cover">
                    <img :src="voiceItem.cover" />
                  </el-row>
                  <el-row class="video-title">
                    <span class="two-line">
                      {{ voiceItem.title }}
                    </span>
                  </el-row>
                  <el-row type="flex" justify="space-between" class="video-info">
                    <el-col :span="12">
                      <span class="section_left" v-if="isEmpty(voiceItem.module) === false">{{ voiceItem.module }}</span>
                      <span class="section_left" v-else>版块名称</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="time"><i class="el-icon-time mr5"></i>{{ voiceItem.releaseTime }}</span>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-row>

          </el-carousel-item>              
        </el-carousel>
        <el-row class="next" type="flex" justify="center" v-show="(isEmpty(wrapperVoiceList) === false) && (wrapperVoiceList.length > 1)">
          <i class="el-icon-arrow-right" @click="arrowClick('next')"></i>
        </el-row>
      </el-row>

    </div>

    <v-footer></v-footer>     
    
    <v-toolbar :scrollPos="scrollPos" scrollContainerId="scroll-container-id"></v-toolbar>

  </div>
</template>
  
<script>
import { getToken } from '@/api/auth'
import { getVoiceList } from "@/api/list";
import header from "@/components/header";
import footer from "@/components/footer";
import customerDppm from "./components/customerDppm"
import customerComplaints from "./components/customerComplaints";
import customerPassRatio from "./components/customerPassRatio";
import failureTimes from "./components/failureTimes";
import appearanceDppm from "./components/appearanceDppm"
import functionDppm from "./components/functionDppm"
import larChart from "./components/larChart"
import damageRatioChart from "./components/damageRatioChart"
import toolbar from "./components/toolbar";
import moment from "moment"
import { AppTabList, AppTabProcessCartoon } from "@/utils/data";
import { mockCustomerComplaintsData, mockCustomerScoreData } from "@/mock/mockData";

import { 
  getCustomerDpmmData,
  getCustomerPassRatioData,
  getFailureTimesData,
  getAppearanceDppmData,
  getFunctionDppmData,
  getLarChartData,
  getDamageChartData,
  getModuleList
} from "@/api/kpi"

import { 
  getCustomerList,
  getCustomerPlantList
} from "@/api/score"

//一屏显示走马灯数量
const CAROUSEL_TOTAL = 4

export default {
  components: {
    "v-header": header,
    "v-footer": footer,
    customerDppm,
    customerComplaints,
    customerPassRatio,
    failureTimes,
    appearanceDppm,
    functionDppm,
    larChart,
    damageRatioChart,
    "v-toolbar": toolbar,
    moment
  },
  data() {
    return {
      selectMonthRange: [],
      selectMonthList: [],

      plantIdSelected: undefined,
      globalPlantList: [],
      plantList: [],

      customerPlantList: [],
      customerList: [],

      appTabSelected: {
        appTabId: undefined,
        appTabName: ''
      },
      appTabList: AppTabList,
      appTabProcessCartoon: AppTabProcessCartoon,

      // applicationList: [],
      // appShowList: [],

      customerDppmData: [],
      customerScoreData: {
        showMonth: [],
        tableData: []
      },
      customerScoreChartData: [],
      customerComplaintsData: [],

      customerPassRatioData: [],

      failureTimesData: [],

      appearanceDppmData: [],
      functionDppmData: [],

      larChartData: [],

      damageRatioChartData: [],

      moduleList: [],
      moduleSelected: undefined,

      pageSize: 10,
      pageNum: 1,
      voiceList: [],
      wrapperVoiceList: [],
      scrollPos: 0
    };
  },
  watch: {
    "$store.state.userData": {
      handler() {
        this.doGetVoiceList();
        this.reloadChartData();
        //this.doGetApplicationList();
      },
    },
    "$store.state.plantList": {
      handler() {
        this.reloadPlantList();
      },
    },
  },
  created() {

    //先检查是否是带后缀跳转回来的
    if('authKey' in this.$route.query) {
      //检查authKey是否为空字符串
      if(this.$route.query.authKey === '' || this.isEmpty(this.$route.query.authKey) === true) {
        //authKey为空,跳转到登录页面
        console.log("authKey is empty, redirect to login");
        this.$redirectToLogin();
        return;
      }
      //有authKey返回,通过authKey去验证token
      console.log("get authKey");
      this.doGetToken(this.$route.query.authKey);
      this.$store.commit("setHasChecked", true);
      this.initView();
    } else if(this.isEmpty(this.$route.query.refresh) === false) {
      //有refresh=1,表示无authKey返回
      //console.log("refresh=1");
      window.open('/#/index','_self');
      this.$store.commit("setHasChecked", true);
      this.initView();
    } else {
      // this.$store.commit("removeAuthKey");
      // this.$store.commit("removeUser");
      // this.$store.commit("removeAccessToken");

      if(JSON.parse(process.env.VUE_APP_AUTO_AUTH) === true) {
        if(this.$store.state.hasChecked === false) {
          //原连接,先去检查authKey
          console.log("this.$getAuthKey!!!")
          this.$getAuthKey();
        } else {
          console.log("nothing to do!!!")
          this.initView();
        }
      } else {
        this.initView();
      }
    }
  },
  methods: {
    doGetToken(fetchedAuthKey) {
      const _this = this;

      if(_this.isEmpty(fetchedAuthKey) === false) {
        _this.$store.commit("setAuthKey", fetchedAuthKey);
        getToken().then(response => {
          if(response.success === true) {
            //其它子系统跳转过来,也置这个标记位
            _this.$store.commit("setAccessToken", fetchedAuthKey);
            setTimeout(() => {
              _this.$store.commit("removeAuthKey", '');
              _this.$doGetProfile();
              window.open('/#/index','_self')
            }, 200);
          } else {
            //token 验证不通过,跳转到登录页面
            _this.$store.commit("logout");
            _this.$redirectToLogin();
          }
        }).catch(() => {
          //token 验证异常,跳转到登录页面
          _this.$store.commit("logout");
          _this.$redirectToLogin();
        });
      }
    },
    initView() {
      //如果是测试版,用app_cartoon文件夹下的图片
      if(process.env.NODE_ENV === 'development') {
        this.appTabList.forEach((item, index)=>{
          if(item.appTabId === 52000) {
            this.appTabList.splice(index, 1, this.appTabProcessCartoon);
          }
        });
      }

      this.appTabSelected = this.appTabList[0];
      sessionStorage.setItem("version", this.apiSettings.VERSION);
      sessionStorage.setItem("compileTime", this.apiSettings.COMPILETIME);
      
      this.reloadPlantList();

      this.doGetModuleList();

      this.doGetCustomerPlantList();

      this.doGetCustomerList();

      //this.doGetApplicationList();

      this.reloadChartData();
    },
    reloadPlantList() {
      this.plantIdSelected = undefined;

      this.plantList = this.$store.state.plantList;
      if(this.isEmpty(this.plantList) === false) {
        this.globalPlantList = [];
        this.globalPlantList.push({
          plantId: 0,
          plantName: "全球"
        });

        this.plantList.forEach(hetPlantItem => {
          this.globalPlantList.push(hetPlantItem);
        });

        this.plantIdSelected = this.globalPlantList[0].plantId;

        this.reloadChartData();
      }
    },
    open(item) {
      console.log("open item: ", item)
      if(item.status == 0) {
        this.msgError(this.$parseLabel('模块开发中...'));
      } else {
        this.$encryption(item.url, item.code)
      }
    },
    jump(list) {
      sessionStorage.setItem("details", JSON.stringify(list));
      window.open('/#/details')
      // this.$router.push({
      //   path: "/details",
      // });
    },
    jumpList() {
      this.$router.push({
        path: "/list",
      });
    },
    async doGetCustomerPlantList() {
      let _this = this;

      this.customerPlantList = [];

      await getCustomerPlantList().then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data) === false)) {
          res.data.forEach(customerPlantItem => {
            _this.customerPlantList.push({
              plantId: parseInt(customerPlantItem.value),
              plantName: customerPlantItem.label
            });
          })
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    async doGetCustomerList() {
      let _this = this;

      this.customerList = [];

      await getCustomerList().then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data.list) === false)) {
          res.data.list.forEach(customerItem => {
            _this.customerList.push({
              customerId: parseInt(customerItem.id),
              customerName: customerItem.name
            });
          })
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    doGetModuleList(){
      let _this = this;
      _this.moduleList = [];
      getModuleList().then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data) === false)) {
          _this.moduleList.push({
            moduleId: 0,
            moduleName: this.$parseLabel('全部')
          });

          res.data.forEach(moduleItem => {
            _this.moduleList.push({
              moduleId: parseInt(moduleItem.id),
              moduleName: moduleItem.label
            });
          });

          _this.moduleList.forEach((moduleItem, index) => {
            if(index === 0) {
              _this.moduleSelected = moduleItem;
              this.doGetVoiceList();
            }
          });
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    handleModuleSelected(item) {
      this.moduleSelected = item;
      this.doGetVoiceList();
    },
    doGetVoiceList() {
      if((this.moduleSelected !== undefined) && (this.moduleSelected.moduleId !== undefined)) {
        getVoiceList(this.moduleSelected).then((res) => {
          if (res.success) {
            res.data.list.forEach(item => {
              item.releaseTime = moment(item.releaseDate).format("YYYY-MM-DD");
            });
            this.voiceList = res.data.list;

            this.wrapperVoiceList = [];
            let tempVoiceList = [];

            for (let index = 0; index <= this.voiceList.length / CAROUSEL_TOTAL; index += 1) {
              tempVoiceList = [];

              for(let tempIndex = 0; tempIndex < CAROUSEL_TOTAL; tempIndex++) {
                let realIndex = index * CAROUSEL_TOTAL + tempIndex;
                if(realIndex < this.voiceList.length) {
                  tempVoiceList[tempIndex] = this.voiceList[realIndex];
                }
              }
              if(tempVoiceList.length > 0) {
                this.wrapperVoiceList.push(tempVoiceList);
              }
            }
          }
        });
      }
    },
    handlePlantChange(sel){
      this.plantIdSelected = sel;
      this.reloadChartData();
    },
    reloadChartData() {
      //let thisMonth = parseInt(moment().format('M'));
      //如果月份大于6个月,则取今年全部
      //否则,补齐六个月
      // if(thisMonth >= 6) {
      //   this.selectMonthRange = [
      //     moment().startOf('year').format('YYYY-MM'),
      //     moment().format('YYYY-MM')
      //   ];
      // } else {
      //   this.selectMonthRange = [
      //     moment().subtract(6, 'months').format('YYYY-MM'),
      //     moment().format('YYYY-MM')
      //   ];
      // }

      //先改用最近一年的数据
      this.selectMonthRange = [
        moment().subtract(11, 'months').format('YYYY-MM'),
        moment().format('YYYY-MM')
      ];

      if(this.isEmpty(this.selectMonthRange) === false) {
        var diffMonths = Math.abs(moment(this.selectMonthRange[0]).diff(this.selectMonthRange[1], 'months'));
        this.selectMonthList = [];
        for(var index = 0; index < diffMonths; index++) {
          this.selectMonthList.push(moment(this.selectMonthRange[0]).add(index, 'months').format('YYYY-MM'));
        }
        
        //APIs
        if((this.isEmpty(this.plantIdSelected) === false) && (this.isEmpty(this.globalPlantList) === false)) {
          this.doGetCustomerDpmmData();
          this.doGetCustomerScoreData();
          this.doGetCustomerComplaintsData();
          this.doGetCustomerPassRatioData();
          this.doGetFailureTimesData();
          this.dogetAppearanceDppmData();
          this.doGetFunctionDpmmData();
          this.doGetLarChartData();
          this.doGetDamageChartData();
        }
      }
    },
    doGetCustomerDpmmData() {
      let _this = this;

      _this.customerDppmData = [];

      getCustomerDpmmData(_this.plantIdSelected, this.selectMonthRange).then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data.list) === false)) {
          if(_this.plantIdSelected === 0) {

            _this.customerDppmData = [];

            // 需要从各数据中去累加得出各月的数值并计算dppm
              _this.selectMonthList.forEach(monthItem => {
              //累计数值
              var deliveryQtySum = 0;
              var goodQtySum = 0;
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  if((_this.isEmpty(recordItem.amountOfGoodsReceived) === false) && (_this.isEmpty(recordItem.inspectionQty) === false)) {
                    deliveryQtySum += recordItem.amountOfGoodsReceived;
                    goodQtySum += recordItem.inspectionQty;
                  }
                }
              })

              if((deliveryQtySum != 0) && (goodQtySum != 0)) {
                _this.customerDppmData.push({
                  month: monthItem,
                  count: parseInt((goodQtySum * 1000000 / deliveryQtySum).toFixed(0)),
                  target: undefined
                })
              }
            });
          } else if(_this.plantIdSelected > 0) {
            
            _this.customerDppmData = [];

            // 直接取dppm
            _this.selectMonthList.forEach(monthItem => {
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  _this.customerDppmData.push({
                    month: recordItem.month,
                    count: recordItem.dppm,
                    target: recordItem.target
                  })
                }
              });
            });
          }
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    doGetCustomerScoreData() {
      let _this = this;
      _this.customerScoreData = {
        showMonth: [],
        tableData: []
      };
      _this.customerScoreChartData = [];
      const scoreData = mockCustomerScoreData(this.selectMonthList);
      if (_this.isEmpty(scoreData) === false) {
        scoreData.showMonth.forEach(monthItem => {
          if (_this.customerScoreData.showMonth.indexOf(monthItem) === -1) {
            _this.customerScoreData.showMonth.push(monthItem);
          }
        });

        _this.customerScoreData.showMonth.sort();

        scoreData.data.forEach(scoreItem => {
          var hetPlant = _this.plantList.find(hetPlantItem => hetPlantItem.plantId === parseInt(scoreItem.hetFactoryIds));
          if(hetPlant != undefined) {
            scoreItem.hetFactoryName = hetPlant.plantName;
          }
          var customer = _this.customerList.find(customerItem => customerItem.customerId === parseInt(scoreItem.customerId));
          if(customer != undefined) {
            scoreItem.customerName = customer.customerName;
          }
          var customerPlant = _this.customerPlantList.find(customerPlantItem => customerPlantItem.plantId === parseInt(scoreItem.customerFactoryIds));
          if(customerPlant != undefined) {
            scoreItem.customerFactoryName = customerPlant.plantName;
          }
        });

        _this.customerScoreData.tableData = scoreData.data;

        _this.selectMonthList.forEach(monthItem => {
          const monthRecords = scoreData.data.filter(item => item.scoreDate === monthItem);
          if (monthRecords.length > 0) {
            const scoreTotal = monthRecords.reduce((sum, item) => sum + Number(item.score || 0), 0);
            const scoreAvg = Number((scoreTotal / monthRecords.length).toFixed(2));
            _this.customerScoreChartData.push({
              month: monthItem,
              count: scoreAvg,
              target: 90
            });
          }
        });
      }
    },
    //客户投诉次数 
    doGetCustomerComplaintsData() {
      let _this = this;
      _this.customerComplaintsData = mockCustomerComplaintsData(this.selectMonthList);
    },
    //客户审核通过率 (%)
    doGetCustomerPassRatioData() {
      let _this = this;

      _this.customerPassRatioData = [];

      getCustomerPassRatioData(_this.plantIdSelected, this.selectMonthRange).then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data.list) === false)) {
          if(_this.plantIdSelected === 0) {
            _this.customerPassRatioData = [];

            // 需要从各数据中去累加得出各月的数值并计算dppm
              _this.selectMonthList.forEach(monthItem => {
              //累计数值
              var auditQtySum = 0;
              var passQtySum = 0;
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  if((_this.isEmpty(recordItem.auditQty) === false) && (_this.isEmpty(recordItem.passQty) === false)) {
                    auditQtySum += parseFloat(recordItem.auditQty);
                    passQtySum += parseFloat(recordItem.passQty);
                  }
                }
              })

              if((auditQtySum != 0) && (passQtySum != 0)) {
                _this.customerPassRatioData.push({
                  month: monthItem,
                  ratio: parseFloat(passQtySum * 100 / auditQtySum).toFixed(2),
                  target: parseFloat(100).toFixed(2)
                })
              }
            });
          } else if(_this.plantIdSelected > 0) {
            _this.customerPassRatioData = [];

            // 直接取dppm
            _this.selectMonthList.forEach(monthItem => {
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  _this.customerPassRatioData.push({
                    month: recordItem.month,
                    ratio: parseFloat(recordItem.passRate).toFixed(2),
                    target: parseFloat(recordItem.target).toFixed(2)
                  })
                }
              });
            });
          }
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    //送样失败次数/小批失败次数(Case)
    doGetFailureTimesData() {
      let _this = this;

      _this.failureTimesData = [];

      getFailureTimesData(_this.plantIdSelected, this.selectMonthRange).then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data.list) === false)) {
          if(_this.plantIdSelected === 0) {

            _this.failureTimesData = [];

            // 需要从各数据中去累加得出各月的数值并计算dppm
              _this.selectMonthList.forEach(monthItem => {
              //累计数值
              var numberOfFailSum = 0;
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  if(_this.isEmpty(recordItem.numberOfFail) === false) {
                    numberOfFailSum += parseInt(recordItem.numberOfFail);
                  }
                }
              })

              if(_this.isEmpty(numberOfFailSum) === false) {
                _this.failureTimesData.push({
                  month: monthItem,
                  times: parseInt(numberOfFailSum),
                  target: 0
                })
              }
            });
          } else if(_this.plantIdSelected > 0) {

            _this.failureTimesData = [];

            // 直接取dppm
            _this.selectMonthList.forEach(monthItem => {
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  _this.failureTimesData.push({
                    month: recordItem.month,
                    times: parseInt(recordItem.numberOfFail),
                    target: parseInt(recordItem.target)
                  })
                }
              });
            });
          }
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    //QA外观DPPM
    dogetAppearanceDppmData() {
      let _this = this;

      _this.appearanceDppmData = [];

      getAppearanceDppmData(_this.plantIdSelected, this.selectMonthRange).then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data.list) === false)) {
          if(_this.plantIdSelected === 0) {

            _this.appearanceDppmData = [];

            // 需要从各数据中去累加得出各月的数值并计算dppm
              _this.selectMonthList.forEach(monthItem => {
              //累计数值
              var testNumberSum = 0;
              var notGoodQtySum = 0;
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  if((_this.isEmpty(recordItem.testNumber) === false) && (_this.isEmpty(recordItem.numberOfBadAppearance) === false)) {
                    testNumberSum +=  parseInt(recordItem.testNumber);
                    notGoodQtySum +=  parseInt(recordItem.numberOfBadAppearance);
                  }
                }
              })

              if((testNumberSum != 0) && (notGoodQtySum != 0)) {
                _this.appearanceDppmData.push({
                  month: monthItem,
                  count: parseInt(notGoodQtySum * 1000000 / testNumberSum),
                  target: undefined
                })
              } else {
                _this.appearanceDppmData.push({
                  month: monthItem,
                  count: 0,
                  target: undefined
                })
              }
            });
          } else if(_this.plantIdSelected > 0) {

            _this.appearanceDppmData = [];

            // 直接取dppm
            _this.selectMonthList.forEach(monthItem => {
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  _this.appearanceDppmData.push({
                    month: recordItem.month,
                    count: recordItem.ppm,
                    target: recordItem.target
                  })
                }
              });
            });
          }
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    //QA功能DPPM
    doGetFunctionDpmmData() {
      let _this = this;

      _this.functionDppmData = [];

      getFunctionDppmData(_this.plantIdSelected, this.selectMonthRange).then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data.list) === false)) {
          if(_this.plantIdSelected === 0) {

            _this.functionDppmData = [];

            // 需要从各数据中去累加得出各月的数值并计算dppm
              _this.selectMonthList.forEach(monthItem => {
              //累计数值
              var testNumberSum = 0;
              var notGoodQtySum = 0;
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  if((_this.isEmpty(recordItem.testNumber) === false) && (_this.isEmpty(recordItem.numberOfDysfunc) === false)) {
                    testNumberSum += parseInt(recordItem.testNumber);
                    notGoodQtySum += parseInt(recordItem.numberOfDysfunc);
                  }
                }
              })

              if((testNumberSum != 0) && (notGoodQtySum != 0)) {
                _this.functionDppmData.push({
                  month: monthItem,
                  count: parseInt(notGoodQtySum * 1000000 / testNumberSum),
                  target: undefined
                })
              } else {
                _this.functionDppmData.push({
                  month: monthItem,
                  count: 0,
                  target: undefined
                })
              }
            });
          } else if(_this.plantIdSelected > 0) {

            _this.functionDppmData = [];

            // 直接取dppm
            _this.selectMonthList.forEach(monthItem => {
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  _this.functionDppmData.push({
                    month: recordItem.month,
                    count: recordItem.ppm,
                    target: recordItem.target
                  })
                }
              });
            });
          }
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    //来料批次合格率(LAR) (%)
    doGetLarChartData() {
      let _this = this;

      _this.larChartData = [];

      getLarChartData(_this.plantIdSelected, this.selectMonthRange).then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data.list) === false)) {
          if(_this.plantIdSelected === 0) {

            _this.larChartData = [];

            // 需要从各数据中去累加得出各月的数值并计算dppm
              _this.selectMonthList.forEach(monthItem => {
              //累计数值
              var testBatchesSum = 0;
              var receivedBatchesSum = 0;
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  if((_this.isEmpty(recordItem.numberOfTestBatches) === false) && (_this.isEmpty(recordItem.numberOfBatchesReceived) === false)) {
                    testBatchesSum += parseFloat(recordItem.numberOfTestBatches);
                    receivedBatchesSum += parseFloat(recordItem.numberOfBatchesReceived);
                  }
                }
              })

              if((testBatchesSum != 0) && (receivedBatchesSum != 0)) {
                _this.larChartData.push({
                  month: monthItem,
                  ratio: parseFloat(receivedBatchesSum * 100 / testBatchesSum).toFixed(2),
                  target: undefined
                })
              }
            });
          } else if(_this.plantIdSelected > 0) {

            _this.larChartData = [];

            // 直接取dppm
            _this.selectMonthList.forEach(monthItem => {
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  _this.larChartData.push({
                    month: recordItem.month,
                    ratio: parseFloat(recordItem.fpyOfIncomingBatch).toFixed(2),
                    target: parseFloat(recordItem.target).toFixed(2)
                  })
                }
              });
            });
          }
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    //质量成本损失率(%)
    doGetDamageChartData() {
      let _this = this;

      _this.damageRatioChartData = [];

      getDamageChartData(_this.plantIdSelected, this.selectMonthRange).then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data.list) === false)) {
          if(_this.plantIdSelected === 0) {

            _this.damageRatioChartData = [];

            // 需要从各数据中去累加得出各月的数值并计算dppm
              _this.selectMonthList.forEach(monthItem => {
              //累计数值
              var outputValueSum = 0;
              var failureCostSum = 0;
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  if((_this.isEmpty(recordItem.outputValue) === false) && (_this.isEmpty(recordItem.failureCost) === false)) {
                    outputValueSum += parseFloat(recordItem.outputValue);
                    failureCostSum += parseFloat(recordItem.failureCost);
                  }
                }
              })

              if((outputValueSum != 0) && (failureCostSum != 0)) {
                _this.damageRatioChartData.push({
                  month: monthItem,
                  ratio: parseFloat(failureCostSum * 100 / outputValueSum).toFixed(2),
                  target: undefined
                })
              }
            });
          } else if(_this.plantIdSelected > 0) {

            _this.damageRatioChartData = [];

            // 直接取dppm
            _this.selectMonthList.forEach(monthItem => {
              res.data.list.forEach(recordItem => {
                if(recordItem.month === monthItem) {
                  _this.damageRatioChartData.push({
                    month: recordItem.month,
                    ratio: parseFloat(recordItem.qualityCostLossRate).toFixed(2),
                    target: parseFloat(recordItem.target).toFixed(2)
                  })
                }
              });
            });
          }
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    handlerScroll(e) {
      this.scrollPos = e.srcElement.scrollTop;
    },
    arrowClick(val) {
      if(val === 'next') {
        this.$refs.carouselRef.next()
      } else {
        this.$refs.carouselRef.prev()
      }
    },
    gotoChart(chart_page) {
      if(chart_page === 'customer_dppm') {
        window.open('#/customer-dppm','_self')
      } else if (chart_page === 'customer_score'){
        this.$encryption(this.apiSettings.SCORE_LINK,'score');
      } else if (chart_page === 'customer_complaints'){
        this.$encryption(this.apiSettings.EIGHTD_LINK,'8d');
      } else if(chart_page === 'customer_pass_ratio') {
        window.open('#/customer-fpy','_self')
      } else if(chart_page === 'failure_times_comparation') {
        window.open('#/failure','_self')
      } else if(chart_page === 'appearance_dppm') {
        window.open('#/appearance-dppm','_self')
      } else if(chart_page === 'function_dppm') {
        window.open('#/function-dppm','_self')
      } else if(chart_page === 'materiallar') {
        window.open('#/lar','_self')
      } else if(chart_page === 'cost_damage') {
        window.open('#/loss-rate','_self')
      } 
    },
    handleAppTabChange(sel){
      this.appTabSelected = sel;
      //this.reloadAppShowList();
    },
    // reloadAppShowList(){
    //   if(this.isEmpty(this.applicationList) === false) {
    //     this.appShowList = [];
    //     this.applicationList.forEach(item => {
    //       if(this.appTabSelected.appNameList.join('|').indexOf(item.name) >= 0) {
    //         this.appShowList.push(item);
    //       }
    //     });
    //   }
    // }
  },
};
</script>
  
<style lang="less" scoped>
.main_title {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  height: 100px;
  line-height: 100px;

  h3 {
    position: relative;
    height: auto;
    line-height: auto;
    font-size: 46px;
    text-align: center;
  }

  h3::before {
    right: 100%;
    margin-right: 40px;
    background-image: url("~@/assets/img/arrow-left.png");
  }

  h3::after {
    left: 100%;
    margin-left: 40px;  
    background-image: url('~@/assets/img/arrow-right.png');
  }

  h3::before, h3::after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 84px;
    height: 16px;
    background-position: center;
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
}

.main_quality_center {
  min-width: 1500px;
  padding-top: 60px;
  padding-bottom: 70px;
  background-color: #FFFFFF;

  .main_plant_select {
    width: 85%;
    margin: 20px auto 0 auto;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;

    ul {
      width: 100%;
      display: flex;
      margin-left: 20px;
      margin-right: 20px;
      list-style: none;
      box-sizing: content-box;

      li {  
        flex: auto;
        width: auto;
        height: max-content;
        display: flex;
        box-sizing: border-box;

        .plant_item {

          width: 100%;
          display: flex;
          box-sizing: border-box;
          padding: 0;
          margin: 0;
          outline: none;

          span {
            width: 100%;
            position: relative;
            color: #606266;
            padding: 10px 0;
            font-size: 22px;
            font-weight: 400;
            text-align: center;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap;
            //transition: all .5s ease-in;
            border-bottom: 1px solid #d2d7e0;
          }

          span:before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 1px;
            background-color: #d2d7e0;
            height: 10px;
          }
        }

        .active {
          box-sizing:border-box;

          span {
            color: var(--topMenuActiveTextColor);
            border-bottom: 2px solid var(--topMenuActiveTextColor);
          }
        }

        .plant_item:hover {
          span {
            color: var(--topMenuActiveTextColor);
            transition: all .2s ease-in-out;
          }
        }
      }

      li:last-child {
        .plant_item {
          
          span:after {
            content: "";
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            width: 1px;
            background-color: #d2d7e0;
            height: 10px;
          }
        }
      }
    }
  }

  .main_chart_grid {
    width: 85%;
    height: auto;
    margin: 0 7.5%;

    .main_chart_col {
      width: 30%;
      margin: 20px; 
      display: block;
      box-sizing: content-box;
    }

    .main_chart_item {
      width: 100%;
      box-shadow: var(--boxShadowLight);
      background-color: #FFFFFF;
      border: 1px solid var(--boxBorder);
      border-radius: var(--commonBorderRadius);
      -webkit-transition: all .3s;
      transition: all .3s;

      h3 {
        font-size: 16px;
        height: 20px;
        line-height: 20px;
        padding: 20px 20px 15px 20px;
        width: 90%;
        margin: 0px;
        text-align: center;
      }
    }

    .main_chart_item:hover {
      transform: translateY(-8px);
      -webkit-transition: all .3s;
      transition: all .3s;
      box-shadow: var(--boxShadowDeep);
      -webkit-transition: all .3s;
      transition: all .3s;
    }
  }
}

.main_module {
  min-width: 1500px;
  padding-top: 60px;
  padding-bottom: 70px;
  background: transparent;

  .main_module_select {
    width: 85%;
    margin: 20px auto 0 auto;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;

    ul {
      width: 100%;
      display: flex;
      margin-left: 10px;
      margin-right: 10px;
      list-style: none;
      box-sizing: content-box;

      li {  
        flex: auto;
        width: auto;
        height: max-content;
        display: flex;
        box-sizing: border-box;

        .app_type_item {

          width: 100%;
          display: flex;
          box-sizing: border-box;
          padding: 0;
          margin: 0;
          outline: none;

          span {
            width: 100%;
            position: relative;
            color: #606266;
            padding: 10px 0;
            font-size: 22px;
            font-weight: 400;
            text-align: center;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap;
            //transition: all .5s ease-in;
            border-bottom: 1px solid #d2d7e0;

            i {
              font-size: 22px;
            }
          }

          span:before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 1px;
            background-color: #d2d7e0;
            height: 10px;
          }
        }

        .active {
          box-sizing:border-box;

          span {
            color: var(--topMenuActiveTextColor);
            border-bottom: 2px solid var(--topMenuActiveTextColor);
          }
        }

        .app_type_item:hover {
          span {
            color: var(--topMenuActiveTextColor);
            transition: all .2s ease-in-out;
          }
        }
      }

      li:last-child {
        // width: 17.5%;

        .app_type_item {

          span:after {
            content: "";
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            width: 1px;
            background-color: #d6dae2;
            height: 10px;
          }
        }
      }
    }
  }

  .main_module_container {

    ul {
      width: 85%;
      margin: auto;
      display: flex;
      flex-wrap: wrap;

      li {
        height: 280px;
        list-style: none;
        display: flex;
        flex-direction: column;
        background-color: transparent;
        margin: 0;
        padding: 0;
        cursor: pointer;

        .module_item_panel {
          width: 100%;
          height: 100%;
          padding: 10px;
          margin: 0;
          display: block;
          border-radius: 10px;
          background-color: transparent;
          // background-size: cover!important;
          // background-position: center!important;
          //box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.1);

          .cover_bg {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 10px;
            background-color: transparent;
            // background-size: cover!important;
            // background-position: center!important;
            overflow: hidden;
            margin-left: auto;
            margin-right: auto;
            position: relative;
            z-index: 1;

            .module_cover {
              width: 100%;
              height: 100%;
              border-radius: 10px;
              display: block;
              pointer-events: auto;
              -webkit-transition: all .3s;
              transition: all .3s;
              margin-left: auto;
              margin-right: auto;
            }

            img:hover {
              transform: scale(1.1);
              -webkit-transition: all .3s ease-in-out;
              transition: all .3s ease-in-out;
            }
          }

          .hui {
            background-color: #FFFFFF!important;
            opacity: 0.5;
          }

          .ccx_mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: black;
            //遮罩层不拦截任何事件
            pointer-events: none;
            opacity: 0.3;
            z-index: 2;
          }

          p {
            position: absolute;
            width: 100%;
            height: 60px;
            line-height: 60px;
            bottom: 0;
            left: 0;
            
            text-align: center;
            font-size: 24px;
            font-weight: 800;
            color: white;
            z-index: 4;
          }
        }

        .module_item_panel_process {
          .cover_bg {
            background-color: #FFFFFF!important;
          }
        }
      }
    }
  }
}

.main_carousel {
  min-width: 1500px;
  padding-top: 60px;
  padding-bottom: 60px;
  background-color: #FFFFFF;

  .module_right {
    width: auto;
    height: 100px;
    line-height: 100px;
    font-size: 30px;
    font-weight: bold;
    position: absolute;
    right: 0;
    display: flex;
    margin-right: 20px;

    .el-dropdown {
      height: 30px; 
      line-height: 30px;
      font-size: 14px;
      color: #000000;
      margin: auto;
      margin-right: 10px;
    }

    p {
      font-size: 14px;
      cursor: pointer;
    }
  }

  .main_carousel_section {
    width: 100%;
    margin: 0;

    .prev {
      position: relative;
      width: 7.5%;
      height: 260px;
      margin: 10px auto;

      i {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        font-size: 32px;
        color: #888888;
      }

      img {
        width: 30px;
        height: 30px;
        margin: auto;
      }
    }

    .carousel {
      width: 85%;
      margin: auto;
    }

    .next {
      position: relative;
      width: 7.5%;
      height: 260px;
      margin: 10px auto;

      i {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        font-size: 32px;
        color: #888888;
      }

      img {
        width: 30px;
        height: 30px;
      }
    }
  }

  .carousel_row {
    width: 100%;
    height: 410px; 

    .carousel_col {
      width: 25%;
      height: 100%;
      display: flex;

      .main_carousel_item {
        width: 100%;
        height: fit-content;
        margin: 10px 15px;
        background-color: transparent;
        border-radius: var(--commonBorderRadius);
        // box-shadow: var(--boxShadowLight);
        -webkit-transition: all .3s;
        transition: all .3s;

        .cover {
          width: 100%;
          height: 260px;
          border-radius: var(--commonBorderRadius);

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: var(--commonBorderRadius);
          }
        }


        .video-title {
          width: 100%;
          padding: 16px 14px; 
          align-items: center;

          .single-line {
            display: inline-block;
            width: 100%;
            height: 25px;
            line-height: 25px;
            font-size: 14px; 
            color: #888888;
            font-weight: 300;
            white-space:nowrap; //禁止换行
            overflow: hidden; //隐藏多出部分文字
            text-overflow: ellipsis; //用省略号代替多出部分文字
          }

          .two-line {
            width: 100%;
            height: 40px;
            line-height: 20px;
            font-size: 18px; 
            font-weight: 700;
            color: #333333;
            display:-webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
            overflow: hidden; //隐藏多出部分文字
            text-overflow: ellipsis; //用省略号代替多出部分文字
          }
        }

        .video-info {
          width: 100%;
          padding: 0px 14px 16px 14px;

          .section_left {
            height: 20px; 
            line-height: 20px;
            float: left;
            font-size: 14px; 
            color: #6b7484; 
            opacity: 1; 
            font-weight: 400;
          }

          .time {
            height: 20px; 
            line-height: 20px;
            float: right;
            font-size: 14px; 
            color: #888888;
            font-weight: 300;
          }
        }
      }

      .main_carousel_item:hover {
        // box-shadow: var(--boxShadowDeep);
        transform: translateY(-8px);
        -webkit-transition: all .3s;
        transition: all .3s;

        .two-line {
          color: var(--commonHoverTextColor);
        }
      }
    }
  }
}

.mr5 {
  margin-right: 5px;
}

.scroll-container {
  position: fixed;
  overflow-y: auto;
  overflow-x: auto;
  top: 0;
  left: 0;
  right:0;
  bottom: 0;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 60px, 0);
    transform: translate3d(0, 60px, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}
.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}

.wow {
    visibility: hidden;
    animation-name: none;
}
</style>
